import React from "react";
import { Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { GatsbyImage } from "gatsby-plugin-image";
import Anchor from "../elements/Anchor";
import "../../styles/components/slices/featured_blog_posts.scss";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";

const FeaturedBlogPosts = ({ slice, context }) => {
  const { posts } = context;

  return (
    <Container fluid className="blogs-section">
      <Container className="max-container">
        <Row className="justify-content-center">
          <Swiper
            navigation
            pagination={{ clickable: true }}
            slidesPerView={3}
            breakpoints={{
              360: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
            spaceBetween={60}
            clickable
            modules={[Navigation, Pagination]}
            className="blog-swiper"
          >
            {posts.edges
              .filter(({ node }) => node.uid !== "egrapsan-gia-emas")
              .map(({ node }) => (
                <SwiperSlide key={node.uid}>
                  <div className="text-center h-100">
                    <Anchor href={node.url}>
                      <GatsbyImage
                        image={node.data.blog_image.gatsbyImageData}
                        alt={node.data.blog_image.alt || "blog image"}
                      />
                      <div className="content-wrapper">
                        <h3 className="tag">{node?.data?.tag}</h3>
                        <h4 className="slab-400 title">
                          {node.data.title.text}
                        </h4>
                        <p className="content mb-0">{node.data.text.text}</p>
                      </div>
                    </Anchor>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </Row>
      </Container>
    </Container>
  );
};

export default FeaturedBlogPosts;
